import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=e56dba06&scoped=true"
import script from "./Suppliers.vue?vue&type=script&lang=js"
export * from "./Suppliers.vue?vue&type=script&lang=js"
import style0 from "./Suppliers.vue?vue&type=style&index=0&id=e56dba06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56dba06",
  null
  
)

export default component.exports